import _axios from '@/assets/utils/_axios'
import Router from '@/router'
import {_loading} from '../../assets/utils/utils'
import HotLetterCity from '@/assets/utils/HotLetterCity.json'             //城市信息
import { data } from 'jquery';

export default {
    //首页模糊搜索
    async POST_SearchDocHotel ({ commit, getters,dispatch }, {data}) {
        //旅行社-酒店-搜索
        let url=data.storeType==2?'/pc/Elasticsearch/SearchDocTravel':'/pc/Elasticsearch/SearchDocHotel'
        let res = await _axios.post(url, {...data});
        if (res.code === '00000'){
            return res.data;
        }
    },
    //首页热门城市
    async POST_GetAllCity ({ commit, getters,dispatch }, {data}) {
        return HotLetterCity;  
        let res = await _axios.post('/pc/Visitor/getAllCity', {...data});
        if (res.code === '00000'){
            
        }
    },
    //首页酒店列表
    async POST_HotelList({ commit, getters,dispatch }, {data}) {
        let res = await _axios.post('/pc/Home/HotelList', {...data});
        if (res.code === '00000'){
            return res;
        }
    },
}